import React from "react";
import { formatDate } from "../../helper/Helper";
import { Link } from "react-router-dom";

const StoreRow = React.memo(
  ({ store, index, page, limit, onStatusChange, onDelete, onCopy }) => {
    const isActive = store.status === "active";

    const getSafeUrl = (url) => {
      if (!url) return "#";

      if (/^https?:\/\//i.test(url)) {
        return url;
      }

      return `https://${url}`;
    };

    return (
      <tr>
        <td>{(page - 1) * limit + index + 1}.</td>
        <td className="text-gray-9">
          <div className="d-flex align-items-center file-name-icon">
            {store.logo && (
              <a
                href={store.logo}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
              >
                <span className="avatar avatar-lg">
                  <img src={store.logo} alt="img" />
                </span>
              </a>
            )}
            <div>
              <h6 className="fw-medium">
                <a
                  href={getSafeUrl(store.websiteUrl)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  {store.name}
                </a>
              </h6>

              <div className="d-flex">
                <span className="fs--1 me-1">{store._id}</span>
                <span
                  className="fs--1 fa fa-copy cursor-pointer"
                  onClick={(e) => onCopy(store._id)}
                ></span>
              </div>
            </div>
          </div>
        </td>
        <td>
          <a
            href={getSafeUrl(store.websiteUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-info"
          >
            {store.websiteUrl}
          </a>
        </td>
        <td>
          <div>
            {store?.email && (
              <a className="text-info" href={`mailto:${store?.email}`}>
                {store?.email}
              </a>
            )}
          </div>
          <div>
            {store?.phone && (
              <a href={`tel:${store?.phone}`} className="text-info">
                +91-{store?.phone}
              </a>
            )}
          </div>
        </td>
        <td>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${
              isActive ? "badge-success" : "badge-danger"
            }`}
          >
            <i className={`ti ${isActive ? "ti-check" : "ti-ban"} me-1`} />
            {isActive ? "Active" : "Inactive"}
          </span>
        </td>
        <td>{formatDate(store.createdAt)}</td>
        <td className="action-table-data">
          <div className="edit-delete-action">
            <button
              className={`btn btn-sm me-2 ${
                isActive ? "btn-danger" : "btn-primary"
              }`}
              onClick={() =>
                onStatusChange(store._id, isActive ? "deactive" : "active")
              }
            >
              {isActive ? "Deactivate" : "Activate"}
            </button>

            <Link
              to={`/stores/edit/${store._id}/general`}
              state={{ name: store.name }}
              className="me-2 p-2"
            >
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={(e) => {
                onDelete(store._id, "store");
              }}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default StoreRow;
